import { Component, Host, h, Event, EventEmitter } from "@stencil/core";
import pfx from "../../utils/style-class-prefix-helper";
import webComponentsDebug from "../../utils/log-helper";
// import { InitLogging } from "../../decorators/init-logging";

/**
 * @slot [unnamed] - holds any number of HTML elements.
 */
@Component({
  tag: "eon-ui-page-wrapper",
  styleUrl: "page-wrapper.scss",
  shadow: true
})
export class PageWrapper {
  // @InitLogging() sentryTransaction;

  /**
   * Raised when the page-wrapper did load.
   */
  @Event() pageWrapperLoad: EventEmitter;

  /**
   * Raised when the page-wrapper will load.
   */
  @Event() pageWrapperWillLoad: EventEmitter;

  componentWillLoad() {
    if (webComponentsDebug) {
      console.time("pageWrapper");
      console.log("Log: page-wrapper will load");
    }
    this.pageWrapperWillLoad.emit();
  }

  componentDidLoad() {
    if (webComponentsDebug) {
      console.log("Log: page-wrapper load");
      console.timeEnd("pageWrapper");
    }
    this.pageWrapperLoad.emit();
  }

  render() {
    return (
      <Host>
        <div class={pfx("page-wrapper")}>
          <slot />
        </div>
      </Host>
    );
  }
}
